module.exports = __webpack_public_path__ + "static/media/service_img1.22d141d3.png";